(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-button"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-slider')) {
    customElements.define(
      'banner-slider',
      class BannerSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.banner-track');
          this.slides = this.querySelectorAll('.banner-slide');
          this.dots = this.querySelectorAll('.banner-dot');
          this.prevBtn = this.querySelector('[data-prev]');
          this.nextBtn = this.querySelector('[data-next]');
          this.count = this.slides.length;
          if (this.count < 2) return;

          this.index = 0;
          this.paused = false;
          this.visible = true;
          this.infinite = this.dataset.infinite === 'true';
          this.speed = Number(this.dataset.speed) || 3000;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.addEventListener('click', this.onClick);
          document.addEventListener('visibilitychange', this.schedule);

          if (this.autoplay) {
            this.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && this.setPaused(true));
            this.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && this.setPaused(false));
            this.addEventListener('focusin', (e) => e.target.matches(':focus-visible') && this.setPaused(true));
            this.addEventListener('focusout', () => this.setPaused(false));

            // only run autoplay while the slider is on screen
            this.io = new IntersectionObserver(([entry]) => {
              this.visible = entry.isIntersecting;
              this.schedule();
            });
            this.io.observe(this);
          }

          this.update();
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          if (this.io) this.io.disconnect();
          document.removeEventListener('visibilitychange', this.schedule);
        }

        onClick = (e) => {
          if (e.target.closest('[data-prev]')) return this.goTo(this.index - 1);
          if (e.target.closest('[data-next]')) return this.goTo(this.index + 1);
          const dot = e.target.closest('[data-dot]');
          if (dot) this.goTo(Number(dot.dataset.dot));
        };

        onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            const i = Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth);
            if (i !== this.index) {
              this.index = i;
              this.update();
            }
          });
        };

        goTo(i) {
          i = this.infinite
            ? (i + this.count) % this.count
            : Math.max(0, Math.min(this.count - 1, i));
          this.track.scrollTo({
            left: i * this.track.clientWidth,
            behavior: this.reduced ? 'auto' : 'smooth',
          });
        }

        setPaused(state) {
          this.paused = state;
          this.schedule();
        }

        schedule = () => {
          clearTimeout(this.timer);
          if (!this.autoplay || this.paused || !this.visible || document.hidden) return;
          if (!this.infinite && this.index === this.count - 1) return;
          this.timer = setTimeout(() => this.goTo(this.index + 1), this.speed);
        };

        update() {
          this.dots.forEach((dot, i) => {
            if (i === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (!this.infinite) {
            if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
            if (this.nextBtn) this.nextBtn.disabled = this.index === this.count - 1;
          }
          this.schedule();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
